/* eslint-disable */
import {
  Component,
  Injector,
  Input,
  ChangeDetectionStrategy,
  Output,
  EventEmitter
} from '@angular/core';
import { BaseRoute } from '../../shared/components/base.route';
import { Portfolio } from '../../shared/models/Recommendation/RecommendationInterfaces';
import { GoalValidationService } from '../../shared/services/goalvalidation.service';
import { QuestionnaireService } from '../../shared/services/questionnaire.service';

@Component({
  selector: 'md-portfolio-summary',
  template: require('./portfolio-summary.component.html'),
  styles: [require('./portfolio-summary.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PortfolioSummaryComponent extends BaseRoute {
  @Output() openAccount = new EventEmitter();

  @Input() set data (data) {
    this.portfolio = data;
  }

  constructor(injector: Injector,
    goalValidation: GoalValidationService,
    questionnaire: QuestionnaireService) {
    super(injector);
    this.goalValidation = goalValidation;
    this.questionnaire = questionnaire;
  }

  onOpenAccount(event) {
    this.openAccount.emit(event);
  }

  makeChangesModal() {
    this.modal.generic({ modalType: 'makeChanges', formData: this.form, title: 'Make changes to your information' });
  }
}
